"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        margin: '0 0 10px',
        padding: '15px 20px',
        fontSize: '22px',
        fontWeight: 300,
        backgroundColor: theme.palette.grey[100],
        borderLeft: "5px solid " + theme.palette.grey[400],
        color: theme.palette.grey[700],
        fontStyle: 'italic',
    },
}); });
var EditorBlockquote = function (_a) {
    var children = _a.children, attributes = _a.attributes, other = __rest(_a, ["children", "attributes"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("blockquote", __assign({}, attributes, { className: classes.root }, other), children));
};
exports.default = EditorBlockquote;
//# sourceMappingURL=EditorBlockQuote.js.map